import Vue from 'vue';
import Autocomplete from 'vuejs-auto-complete';

Vue.use(Autocomplete);
